<template>
    <div>
        
        <!-- 文章 -->
        <div
            class = "theme_type_1"
            v-if  = "moduleItem.content_type == 0"
        >
            <div class="theme_type_1_cnt">
                <div class="p1"
                    @click="goDetail(moduleItem.content_uid, moduleItem.content_type, moduleItem.content_id)"
                    v-html="moduleItem.title"
                ></div>
                <div class="p2"
                    v-html="moduleItem.summary"
                ></div>
            </div>
            <div class="theme_type_1_img">
                <img :src="img_req_url + moduleItem.logo_path" @click="goDetail(moduleItem.content_uid, moduleItem.content_type, moduleItem.content_id)"/>
            </div>
        </div>

        <!-- 快讯 -->
        <div
            class = "theme_type_2"
            v-if  = "moduleItem.content_type == 1"
        >
            <div class="theme_type_2_cnt">
                <p class="p1" @click="goDetail(moduleItem.content_uid, moduleItem.content_type, moduleItem.content_id)">
                    <span class="title">{{moduleItem.title}}</span>
                    <span class="time">{{moduleItem.publish_time | time_standard}}</span>
                </p>
                <p class="p2">{{moduleItem.summary}}</p>
                <div class="div-img" v-if="moduleItem.file_arr && moduleItem.file_arr.length > 0">
                    <img
                        v-for="(imgItem, imgIndex) in moduleItem.file_arr"
                        :preview="moduleId + moduleItem.id"
                        :key="imgIndex"
                        :src="img_req_url + imgItem.path"
                    />
                </div>
            </div>
        </div>

        <!-- 专题 -->
        <div
            class = "theme_type_1"
            v-if  = "moduleItem.content_type == 2 || moduleItem.content_type == 3"
        >
            <div class="theme_type_1_cnt">
                <div class="p1" @click="goDetail(moduleItem.content_uid, moduleItem.content_type, moduleItem.content_id)">{{moduleItem.title}}</div>
                <div class="p2">{{moduleItem.summary}}</div>
            </div>
            <div class="theme_type_1_img">
              <img :src="img_req_url + moduleItem.share_logo_path" @click="goDetail(moduleItem.content_uid, moduleItem.content_type, moduleItem.content_id)"/>
              <span class="theme-tag-2">专题</span>
            </div>
        </div>

        <!-- 政策 -->
        <div
            class = "theme_type_3"
            v-if  = "moduleItem.content_type == 5"
        >
            <p class="p1" @click="goDetail(moduleItem.content_uid, moduleItem.content_type, moduleItem.content_id)"><span>政策</span>{{moduleItem.title}}</p>
            <p class="p2">
                <span>发文时间：{{moduleItem.publish_time | time_standard}}</span>
                <span v-if="moduleItem.address_id && moduleItem.address_id != '0'">有效地区：{{moduleItem.address_id | addressDeal('3', meta.address)}}</span>
                <span v-if="moduleItem.publish_org">发文机关：{{moduleItem.publish_org}}</span>
            </p>
        </div>

        <!-- 报告 -->
        <div
            class = "theme_type_1"
            v-if  = "moduleItem.content_type == 11"
        >
            <div class="theme_type_1_cnt">
                <div class="p1"
                    @click="goDetail(moduleItem.content_uid, moduleItem.content_type, moduleItem.content_id)"
                    v-html="moduleItem.title"
                ></div>
                <div class="p3"
                    v-html="moduleItem.summary"
                ></div>
            </div>
            <div class="theme_type_1_img img2">
                <div class="left-top">报告</div>
                <img :src="img_req_url + moduleItem.logo_path" @click="goDetail(moduleItem.content_uid, moduleItem.content_type, moduleItem.content_id)"/>
            </div>
        </div>

        <div class="remark" v-if="moduleInsight.findIndex((a) => a.module_theme_id == moduleItem.module_theme_id) > -1">
            <i class="iconfont before_icon">&#xe6be;</i>
            <p
                v-for="remarkItem in moduleInsight"
                v-if="moduleItem.module_theme_id == remarkItem.module_theme_id"
            >
              {{remarkItem.content}}
              <!-- <span>（动脉网编辑{{remarkItem.create_user_name}},供行业人士参考）</span> -->
            </p>
            <i class="iconfont after_icon">&#xe6bf;</i>
        </div>
    </div>
</template>
<script>
export default {
  inject: ['goDetail', 'goAuthor'],
  props: ['moduleItem', 'moduleInsight', 'moduleId', 'meta'],
  computed: {
    img_req_url() {
      return this.$store.state.img_req_url
    }
  },
  created() {
    // console.log(this.moduleItem)
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.theme_type_1
  display: flex
  &_img
    flex: 0 0 122px
    height: 76px
    position: relative
    overflow: hidden
    img
      width: 100%
      height: 100%
      display: block
      cursor: pointer
      transition_02s()
    &.img2
      flex: 0 0 166px
      height: 100px
      position relative
      .left-top
        position absolute
        width 50px
        height 24px
        background linear-gradient(90deg, #54B6E7, #1E7CE2)
        display: flex
        justify-content: center
        align-items: center
        font-size 14px
        color #FFFFFF
        line-height: 1
        z-index 2
    &:hover img
      transform: scale(1.1)
    span
      position: absolute
      top: 0
      left: 0
      color: #fff
      font-size: 12px
      padding: 4px 10px
      &.theme-tag-2
        background: rgba(250, 122, 80, 1)
        background: linear-gradient(180deg,rgba(84,182,231,1) 0%,rgba(30,124,226,1) 100%)
  &_cnt
    flex: auto
    position: relative
    margin-right: 20px
    .p1
      font-size: 16px
      commonColor(#E9E9EB, #333333)
      font-weight: 600
      line-height: 24px
      max-height: 56px
      margin: -2px 0 -4px
      ellipsisClamp2()
      cursor: pointer
      &:hover
        color: rgba(250, 122, 80, 1)
    .p2
    .p3
      font-size: 14px
      commonColor(#bcbdc1, #666666)
      line-height: 20px
      
      margin: 10px 0 -3px
    .p2
      width: 558px
      max-height: 20px
      ellipsis()
    .p3
      ellipsisClamp2()
      -webkit-line-clamp: 3
    .dec
      position: absolute
      bottom: 6px
      .author
        float: left
        font-size: 0
        margin-right: 20px
        img
          width: 24px
          height: 24px
          border-radius: 50%
          cursor: pointer
        span
          font-size: 14px
          commonColor(#bcbdc1, #999999)
          line-height: 24px
          display: inline-block
          vertical-align: top
          margin-left: 10px
          cursor: pointer
          &:hover
            color: rgba(250, 122, 80, 1)
      .time
        float: left
        font-size: 14px
        commonColor(#bcbdc1, #999999)
        line-height: 24px
.theme_type_2
  &_cnt
    .p1
      display: flex
      justify-content: flex-end
      .title
        flex: auto
        font-size: 16px
        commonColor(#FFFFFF, #333333)
        line-height: 22px
        font-weight: 600
        max-width: 620px
        cursor: pointer
        white-space: nowrap
        ellipsis()
        &:hover
          color: rgba(250, 122, 80, 1)
      .time
        line-height: 16px
        text-align: right
        flex: 0 0 80px
        font-size: 12px
        line-height: 22px
        commonColor(#797B83, #999999)
    .p2
      font-size: 14px
      color: #bcbdc1
      commonColor(#bcbdc1, #666666)
      line-height: 22px
      margin: 10px 0 -3px
      span
        commonColor(#797b83, #AAAAAA)
.theme_type_3
  .p1
    font-size:16px
    commonColor(#FFFFFF, #333333)
    cursor: pointer
    font-weight: 600
    line-height:22px
    margin: -3px 0
    span
      margin-right: 21px
      position: relative
      &:before
        content: ''
        position: absolute
        width: 1px
        height: 15px
        commonBgColor(#40444F, #E9E9E9)
        right: -11px
        top: 1px
    &:hover
      color: rgba(250, 122, 80, 1)
      span:before
        background-color: rgba(250, 122, 80, 1)
  .p2
    margin-top: 10px
    font-size:14px
    commonColor(#bcbdc1, #666666)
    display: -webkit-box
    overflow: hidden
    text-overflow: ellipsis
    word-break: break-all
    -webkit-box-orient: vertical
    -webkit-line-clamp: 1
    height: 14px
    line-height: 14px
    span+span
      margin-left: 29px
      position: relative
      &:before
        content: ''
        position: absolute
        width: 1px
        height: 12px
        commonBgColor(#40444F, #E9E9E9)
        left: -14px
        top: 3px
.describe
  >div
    padding: 20px 20px 20px 46px
    position: relative
    &+div
        margin-top: 1px
        &:after
          content: ''
          position: absolute
          height: 1px
          width: 880px
          commonBgColor(#40444f, #e8e8e8)
          top: -1px
          left: 20px
          right: 20px
    .p1
      font-size: 16px
      line-height: 24px
      commonColor(#E9E9EB, #333333)
      font-weight: 600
    .p2
      margin-top: 8px
      font-size: 14px
      commonColor(#bcbdc1, #666666)
      line-height: 22px
      margin-bottom: -4px
    .img-show
      margin-top: 16px
      img
        display: inline-block
        vertical-align: top
        width: 242px
        height: 152px
        cursor: pointer
        &+img
          margin-left: 16px
    &:before
      content: ''
      position: absolute
      width: 16px
      height: 16px
      background-image: url('~pic/remark_icon.png')
      background-size: 100%
      top: 23px
      left: 20px
.remark
  commonBgColor(#2A2F42, #F9F9F9)
  position: relative
  padding: 0 42px
  margin-top: 18px
  &:before
    content: ''
    position: absolute
    width: 25px
    height: 9px
    commonBgImg('~pic/s_up_icon.png', '~pic/s_up_icon2.png')
    background-size: 100% !important
    top: -8px
    left: 20px
  p
    padding: 15px 0
    font-size: 14px
    line-height: 22px
    commonColor(#BCBDC1, #666666)
    &+p
      border-top: 1px solid
      commonBorderColor(#40444F, #E9E9E9)
    span
      commonColor(#797b83, #AAAAAA)
  i
    position: absolute
    commonColor(#0050B3, #C2DAFA)
    font-size: 16px
    top: 16px
    left: 16px
    &.after_icon
      top: auto
      left: auto
      bottom: 16px
      right: 16px
.div-img
  margin-top: 10px
  font-size: 0
  line-height: 1
  img
    max-width: 160px
    max-height: 80px
    cursor: pointer
  img+img
    margin-left: 10px
</style>
